import map from "lodash/map"
import filter from "lodash/filter"
import numeral from 'numeral';

import { ALL_INDEXES, formatNumberTypes, LIST_TAB_PB_ID } from "@/stores/dataStore/memoryStore/const/constIndex"
import { ISymbolsGroup } from "../dataStore/reduxStore/symbol/interfaceSymbol"
export class convertData {
    static parseSymbolsList = (rawInstrument: any) => {
        try {
            let data = map(rawInstrument, (i) => {
                let item = {
                    KEY: i.symbol,
                    SB: i.symbol,
                    FN: i.FullName,
                    ST: i.StockType,
                    EX: i.exchange,
                    FC: i.FloorCode,
                    CL: i.ceiling,
                    FL: i.floor,
                    RE: i.reference,
                }
                return item
            })
            return data
        }
        catch (e) {
            return []
        }
    }
    // LIST_TAB_PB_ID[idPbTab]['exchange']
    static parsesymbolsGroup = (rawInstrument: any) => {
        try {
            let data: ISymbolsGroup[] = []
            let symbols = {
                [LIST_TAB_PB_ID['HOSE']['id']]: Array(),
                [LIST_TAB_PB_ID['HNX']['id']]: Array(),
                [LIST_TAB_PB_ID['UPCOM']['id']]: Array()
            }
            let symbols_data = {
                [LIST_TAB_PB_ID['HOSE']['id']]: Array(),
                [LIST_TAB_PB_ID['HNX']['id']]: Array(),
                [LIST_TAB_PB_ID['UPCOM']['id']]: Array()
            }
            filter(rawInstrument, (e: any) => {
                if (e.EX === LIST_TAB_PB_ID['HOSE']['exchange'] && e.ST && e.ST !== "1" && e.ST !== "4" && e.ST !== "3") {
                    symbols[LIST_TAB_PB_ID['HOSE']['id']].push(e?.SB)
                    symbols_data[LIST_TAB_PB_ID['HOSE']['id']].push(e)
                }
                if (e.EX === LIST_TAB_PB_ID['HNX']['exchange'] && e.ST && e.ST !== "1" && e.ST !== "4" && e.ST !== "3") {
                    symbols[LIST_TAB_PB_ID['HNX']['id']].push(e?.SB)
                    symbols_data[LIST_TAB_PB_ID['HNX']['id']].push(e)
                }
                if (e.EX === LIST_TAB_PB_ID['UPCOM']['exchange'] && e.ST && e.ST !== "1" && e.ST !== "4" && e.ST !== "3") {
                    symbols[LIST_TAB_PB_ID['UPCOM']['id']].push(e?.SB)
                    symbols_data[LIST_TAB_PB_ID['UPCOM']['id']].push(e)

                }
                return e
            })
            // console.log("parsesymbolsGroup.:1", { symbols, symbols_data, rawInstrument })
            data.push({
                KEY: LIST_TAB_PB_ID['HOSE']['id'],
                ID: LIST_TAB_PB_ID['HOSE']['id'],
                SYMBOLS: symbols[LIST_TAB_PB_ID['HOSE']['id']],
                SYMBOLS_DATA: symbols_data[LIST_TAB_PB_ID['HOSE']['id']]
            })
            data.push({
                KEY: LIST_TAB_PB_ID['HNX']['id'],
                ID: LIST_TAB_PB_ID['HNX']['id'],
                SYMBOLS: symbols[LIST_TAB_PB_ID['HNX']['id']],
                SYMBOLS_DATA: symbols_data[LIST_TAB_PB_ID['HNX']['id']]
            })
            data.push({
                KEY: LIST_TAB_PB_ID['UPCOM']['id'],
                ID: LIST_TAB_PB_ID['UPCOM']['id'],
                SYMBOLS: symbols[LIST_TAB_PB_ID['UPCOM']['id']],
                SYMBOLS_DATA: symbols_data[LIST_TAB_PB_ID['UPCOM']['id']]
            })
            return data
        }
        catch (e) {
            return []
        }
    }



    static parseInstrumentsStatic = (rawInstrument: any) => {
        try {
            let data = map(rawInstrument, (i) => {
                let item = {
                    KEY: i.symbol,
                    SB: i.symbol,
                    FN: i.FullName,
                    ST: i.ST,
                    EX: i.exchange,
                    FC: i.FloorCode,
                    CL: i.ceiling,
                    FL: i.floor,
                    RE: i.reference,
                }
                return item
            })
            return data
        }
        catch (e) {
            return []
        }
    }

    static parseInstrumentsDynamic = (rawInstrument: any) => {
        try {
            let data = map(rawInstrument, (i) => {
                let item = {
                    KEY: i.symbol,
                    Id: i.id,
                    SB: i.symbol,
                    SI: i.StockId,
                    FN: i.FullName || "",
                    TD: i.tradingdate,
                    FC: i.FloorCode,
                    ST: i.ST,
                    CL: i.ceiling || "",
                    FL: i.floor,
                    RE: i.reference,
                    B3: i.bidPrice3,
                    V3: i.bidVol3 || "",
                    B2: i.bidPrice2,
                    V2: i.bidVol2 || "",
                    B1: i.bidPrice1,
                    V1: i.bidVol1 || "",
                    CP: i.closePrice,
                    // P4A: i.price4Asset, // Không lấy trường này từ api instrument
                    CV: i.closeVol || "",
                    CH: i.change,
                    S1: i.offerPrice1,
                    U1: i.offerVol1 || "",
                    S2: i.offerPrice2,
                    U2: i.offerVol2 || "",
                    S3: i.offerPrice3,
                    U3: i.offerVol3 || "",
                    TT: i.totalTrading || "",
                    TV: i.totalTradingValue || "",
                    AP: i.averagePrice,
                    OP: i.open,
                    HI: i.high,
                    LO: i.low,
                    FB: i.foreignBuy || "",
                    FS: i.foreignSell || "",
                    FR: i.foreignRemain || "",
                    SS: i.Status,
                    EX: i.exchange,
                    OI: i.openInterest,
                    LTD: i.lastTradingDate,
                    ULS: i.underlyingSymbol || "",
                    ULP: i.underlyingPrice,
                    IN: i.IssuerName,
                    MD: i.MaturityDate,
                    CHP: i.changePercent,
                    percent: Number(i.changePercent) * 1000 || 0,
                    EP: i.ExercisePrice,
                    ER: i.ExerciseRatio,
                    FO: i.foreignRoom || "",
                    PMP: i.PT_MATCH_PRICE,
                    PMQ: i.PT_MATCH_QTTY,
                    PTQ: i.PT_TOTAL_TRADED_QTTY,
                    PTV: i.PT_TOTAL_TRADED_VALUE,
                    PP: i.PRIOR_PRICE,
                    TO: i.TOTAL_OFFER_QTTY,
                    TB: i.TOTAL_BID_QTTY,
                    FT: i.FundType || "",
                    BEP: 0,
                    s: 0,
                    ts: 0,
                }
                return item
            })
            return data
        }
        catch (e) {
            return []
        }
    }

    static processJSON_MarketInfos(proto: any) {
        let object = {};
        try {
            if (proto && proto.length > 0) {
                for (let key in proto) {
                    if (proto[key] && proto[key].marketCode) {
                        let _object = {
                            [proto[key].marketCode]: {
                                // "crrTime": proto[key].indexTime ? proto[key].indexTime : '',
                                // "data": {
                                advance: proto[key].advances
                                    ? parseFloat(proto[key].advances)
                                    : "", // 6
                                changedIndex: proto[key].indexChange
                                    ? parseFloat(proto[key].indexChange)
                                    : "", //2
                                // "dateNo": "3559",
                                decline: proto[key].declines
                                    ? parseFloat(proto[key].declines)
                                    : "", // 8
                                floorCode: proto[key].marketCode,
                                //"highestIndex": 109.917036,
                                //"lowestIndex": 107.152126,
                                marketIndex: proto[key].marketIndex
                                    ? parseFloat(proto[key].marketIndex)
                                    : "", // 1
                                noChange: proto[key].noChange
                                    ? parseFloat(proto[key].noChange)
                                    : "", // 7
                                indexColor: proto[key].indexColor ? proto[key].indexColor : "noChange",
                                percentIndex: proto[key].indexPercentChange
                                    ? parseFloat(proto[key].indexPercentChange)
                                    : "-", // 3
                                priorMarketIndex: proto[key]
                                    .PRV_PRIOR_MARKET_INDEX
                                    ? parseFloat(
                                        proto[key].PRV_PRIOR_MARKET_INDEX
                                    )
                                    : "",
                                totalShareTraded: proto[key].totalVolume
                                    ? parseFloat(proto[key].totalVolume)
                                    : "", // 4
                                totalStock: proto[key].totalVolume
                                    ? parseFloat(proto[key].totalVolume)
                                    : "",
                                totalTrade: proto[key].totalValue
                                    ? parseFloat(proto[key].totalValue)
                                    : "",
                                totalValueTraded: proto[key].totalValue
                                    ? parseFloat(proto[key].totalValue)
                                    : "", // 5
                                tradingDate: proto[key].tradingdate
                                    ? proto[key].tradingdate
                                    : "" + " " + proto[key].indexTime ? proto[key].indexTime : "",
                                tradingTime: proto[key].indexTime
                                    ? proto[key].indexTime
                                    : "",
                                status: proto[key].marketStatus
                                    ? proto[key].marketStatus
                                    : "", // 9 ghép tạm
                                openMarketIndex: proto[key].marketIndex
                                    ? parseFloat(proto[key].marketIndex)
                                    : undefined,
                                numberOfCe: proto[key].numberOfCe ? parseFloat(proto[key].numberOfCe) : "",
                                numberOfFl: proto[key].numberOfFl ? parseFloat(proto[key].numberOfFl) : "",
                                oddLotTotalValue: proto[key].oddLotTotalValue
                                    ? parseFloat(proto[key].oddLotTotalValue)
                                    : "",
                                oddLotTotalVolume: proto[key].oddLotTotalVolume
                                    ? parseFloat(proto[key].oddLotTotalVolume)
                                    : "",
                                ptTotalValue: proto[key]["PT_TOTAL_VALUE"]
                                    ? parseFloat(proto[key]["PT_TOTAL_VALUE"])
                                    : "",
                                ptTotalVolumn: proto[key]["PT_TOTAL_TRADE"]
                                    ? parseFloat(proto[key]["PT_TOTAL_TRADE"])
                                    : ""
                            },
                        };
                        Object.assign(object, _object);
                    }
                }
            }
        } catch (error) {
            console.log(
                "Haki.:<util>.:processJSON_MarketInfos().: error=",
                error
            );
            return {};
        }
        return object;
    }

    static formatNumberWithCommas(nStr: string) {
        nStr += "";
        let x = nStr.split(".");
        let x1 = x[0];
        let x2 = x.length > 1 ? "." + x[1] : "";
        let rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, "$1,$2");
        }
        return x1 + x2;
    }

    static formatAccounting(number: any, fixed?: any) {
        if (number && number != "") {
            let result =
                fixed > 0
                    ? Number(number)
                        .toFixed(fixed)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
                    : this.formatNumberWithCommas(number.toFixed(0));

            if (Number(result) == 0) {
                return "";
            }

            return result;
        } else {
            return "";
        }
    }

    static populateMarketInfo(marketInfo: any) {
        let info: any = {};
        if (marketInfo) {
            let index = ALL_INDEXES.find(item => item.code === marketInfo.floorCode);
            info.indexName = index ? index.title : '';
            info.marketIndex = this.formatAccounting(marketInfo.marketIndex, 2);
            info.changeValue = marketInfo.changedIndex;

            // info.changePercent = info.changeValue / marketInfo.priorMarketIndex;
            info.changePercent = marketInfo.percentIndex; // Haki.: Lấy trực tiếp từ data trả về
            info.changeValue = this.formatAccounting(
                // Math.abs(info.changeValue),
                info.changeValue,
                2
            );
            // info.changePercent =
            // 	Util.formatAccounting(100 * Math.abs(info.changePercent), 2) +
            // 	'%';
            // info.totalShareTraded = Util.formatAccounting(
            // 	10 * marketInfo.totalShareTraded,
            // 	0
            // );

            // Tổng KL hiển thị = Tổng KL + Tổng KL lô lẻ
            // Tổng GT hiển thị = Tổng GT + Tổng GT lô lẻ
            info.totalShareTradedInfo = this.formatAccounting(
                Number(marketInfo.totalShareTraded) + Number(marketInfo.oddLotTotalVolume),
                0
            );
            info.totalValueTradedInfo = this.formatNumberShortLargeByDigit(Number(marketInfo.totalValueTraded) + Number(marketInfo.oddLotTotalValue), formatNumberTypes.ONE_DIGITS)

            info.totalShareTraded = this.formatAccounting(
                marketInfo.totalShareTraded,
                0
            );
            // info.totalValueTraded = Util.formatAccounting(
            // 	marketInfo.totalValueTraded,
            // 	3
            // );
            info.totalValueTraded = this.formatNumberShortLarge(marketInfo.totalValueTraded)

            info.advance = marketInfo.advance;
            info.noChange = marketInfo.noChange;
            info.decline = marketInfo.decline;
            info.numberOfCe = marketInfo.numberOfCe;
            info.numberOfFl = marketInfo.numberOfFl;
            info.colorClass = (this.getMarketInfoClasses(marketInfo) as any).color;
            info.arrowClass = (this.getMarketInfoClasses(marketInfo) as any).arrow;
            info.statusKey = this.getMarketStatusKey(marketInfo);
            info.floorCode = marketInfo.floorCode;
            info.priorMarketIndex = marketInfo.priorMarketIndex;
            info.name = index ? index.name : ""
            info.subName = index ? index.subName : ""
        }

        return info;
    }

    static formatNumberShortLarge(costOfIt: any) {
        var number = costOfIt;
        if (costOfIt) {
            if (isNaN(costOfIt)) return 0;
            if (costOfIt > 1000000000) number = numeral(Number(costOfIt) / 1000000000).format(formatNumberTypes.THREE_DIGITS);
            else if (costOfIt > 1000000) number = numeral(Number(costOfIt) / 1000000).format(formatNumberTypes.THREE_DIGITS);
            else number = numeral(Number(costOfIt)).format(formatNumberTypes.THREE_DIGITS);
        }
        return number;
    }
    static formatNumberShortLargeByDigit(costOfIt: any, digitFormat: any) {
        var number = costOfIt;
        if (costOfIt) {
            // Nếu có format thì theo format truyền vào còn lại mặc định để 2 số sau dấu ,
            if (isNaN(costOfIt)) return 0;
            if (digitFormat && Object.values(formatNumberTypes).includes(digitFormat)) {
                if (costOfIt > 1000000000) number = numeral(Number(costOfIt) / 1000000000).format(digitFormat);
                else if (costOfIt > 1000000) number = numeral(Number(costOfIt) / 1000000).format(digitFormat);
                else number = numeral(Number(costOfIt)).format(digitFormat);
            } else {
                if (costOfIt > 1000000000) number = numeral(Number(costOfIt) / 1000000000).format(formatNumberTypes.TWO_DIGITS);
                else if (costOfIt > 1000000) number = numeral(Number(costOfIt) / 1000000).format(formatNumberTypes.TWO_DIGITS);
                else number = numeral(Number(costOfIt)).format(formatNumberTypes.TWO_DIGITS);
            }
        }
        return number;
    }

    static getMarketStatusKey(marketInfo: any) {
        var vStatus;
        switch (marketInfo.status) {
            case 'A':
            case 'S':	// thêm mới
            case '30':
                vStatus = 'atc';
                break;
            case 'C':
            case '35':
                vStatus = 'putThrough';
                break;
            case 'G':
            case 'J':
            case 'K':
            case 'Z':
            //hnx-upcom
            case '13':
            case '6':
                vStatus = 'closed';
                break;
            case 'I':
            case 'L': // thêm mới
            case '10':
                vStatus = 'intermission';
                break;
            case 'F':
            case 'M': // thêm mới
            //hnx-upcom
            // case '10':
            //     vStatus = 'pause';
            //     break;

            case 'O':
            case 'E': // thêm mới
            //hnx-upcom
            case '5':
                vStatus = 'continuous';
                break;
            case 'P':
                vStatus = 'ato';
                break;
            case '2':
                break;
            default:
                vStatus = 'closed';
        }
        return vStatus;
    }

    static getMarketInfoClasses(marketInfo: any) {
        let cl = {};
        //let index = Number(marketInfo.marketIndex);

        // if (
        // 	MarketInfoService.isATOStatus(marketInfo) &&
        // 	marketInfo.predictionMarketIndex
        // ) {
        // 	index = Number(marketInfo.priorMarketIndex);
        // }

        // if (
        // 	MarketInfoService.isATCStatus(marketInfo) &&
        // 	marketInfo.predictionMarketIndex
        // ) {
        // 	index = Number(marketInfo.marketIndex);
        // }

        if (marketInfo.indexColor == 'up') {
            cl = {
                color: "txt-lime",
                arrow: "icon-arrowup",
            };
        } else if (marketInfo.indexColor == 'down') {
            cl = {
                color: "txt-red",
                arrow: "icon-arrowdown",
            };
        } else {
            cl = {
                color: "txt-gia-tc",
                arrow: "icon-square",
            };
        }

        return cl;
    }

}